export default __webpack_public_path__ + "static/media/icon-message.7b14dcea.svg";